<tec-modal [isVisible]="isVisible" [title]="'OCR.BACK.MODAL_HELP.TITLE' | translate" (closeEvent)="closeModal()">
    <ng-container body>
        @if (showHelpContent) {
            <div [ngClass]="{ grid: true, 'grid-e2': operation?.config?.available_method?.length }">
                @if (operation?.config?.available_method?.length) {
                    <tec-tile [title]="'OCR.BACK.MODAL_HELP.DOC' | translate" icon="icon-card">
                        <span [innerHTML]="'OCR.BACK.MODAL_HELP.DOC_DESCRIPTION' | translate"></span>
                        @for (doc of operation?.config?.available_method; track doc; let isLast = $last; let index = $index) {
                            <span>
                                <b>{{ doc.required ? 'Obligatorio' : 'OPCIÓN ' + (index + 1) }}</b>
                                {{ doc.title }}
                            </span>
                            @if (!isLast) {
                                <tec-divider />
                            }
                        }
                    </tec-tile>
                }

                <tec-tile [title]="'OCR.BACK.MODAL_HELP.TIPS' | translate" icon="icon-help-circle">
                    <div class="grid grid-e2">
                        <div class="image-group">
                            <pwcs-inline-svg
                                [src]="
                                    'assets/images/id-blurred' + (designService.isDarkMode() ? '-dark' : '') + '.svg'
                                "
                                idSuffix="modal-help-doc-id-blurred"
                            />
                            <span>{{ 'OCR.BACK.MODAL_HELP.TIP_1' | translate }}</span>
                        </div>
                        <div class="image-group">
                            <pwcs-inline-svg
                                [src]="'assets/images/id-bright' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                                idSuffix="modal-help-doc-id-bright"
                            />
                            <span>{{ 'OCR.BACK.MODAL_HELP.TIP_2' | translate }}</span>
                        </div>
                        <div class="image-group">
                            <pwcs-inline-svg
                                [src]="'assets/images/id-cut' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                                idSuffix="modal-help-doc-id-cut"
                            />
                            <span>{{ 'OCR.BACK.MODAL_HELP.TIP_3' | translate }}</span>
                        </div>
                        <div class="image-group">
                            <pwcs-inline-svg
                                [src]="'assets/images/id-finger' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                                idSuffix="modal-help-doc-id-finger"
                            />
                            <span>{{ 'OCR.BACK.MODAL_HELP.TIP_4' | translate }}</span>
                        </div>
                    </div>
                </tec-tile>
            </div>
            <span style="text-align: center">
                {{ 'OCR.BACK.MODAL_HELP.HAS_PROBLEMS' | translate }}
                <a (click)="showHelpContent = !showHelpContent">{{
                    'OCR.BACK.MODAL_HELP.CHANGE_DEVICE' | translate
                }}</a>
            </span>
        }
        @if (!showHelpContent) {
            <div class="grid" style="justify-items: center">
                <span>{{ 'OCR.BACK.MODAL_SCAN.DESCRIPTION' | translate }}</span>
                <tec-qr [url]="url" />
            </div>
            <span style="text-align: center">
                {{ 'OCR.BACK.MODAL_HELP.HAS_PROBLEMS_2' | translate }}
                <a (click)="showHelpContent = !showHelpContent">{{ 'OCR.BACK.MODAL_HELP.CHANGE_TIP' | translate }}</a>
            </span>
        }
    </ng-container>
</tec-modal>
